import React, { useState, useEffect } from 'react';

const KLUBOVI = ['KK Rad', 'KK Rad 2', 'ŽKK Olimp'];
const SEZONE = ['2025/2026', '2026/2027'];

// Pozicije čunjeva (viewBox 0 0 110 110)
const CUNJEVI = [
  { id: 1, cx: 55, cy: 100 },
  { id: 2, cx: 30, cy: 78  },
  { id: 3, cx: 80, cy: 78  },
  { id: 4, cx: 7,  cy: 55  },
  { id: 5, cx: 103,cy: 55  },
  { id: 6, cx: 30, cy: 32  },
  { id: 7, cx: 80, cy: 32  },
  { id: 8, cx: 55, cy: 10  },
  { id: 9, cx: 55, cy: 55  },
];

// SVG dijagram za PDF (crno-bijeli, statički HTML string)
const makePinSVG = (odabrani = [], size = 88) => {
  const pins = CUNJEVI.map(p => {
    const sel = odabrani.includes(p.id);
    const fill   = sel ? '#cc2244' : '#fff';
    const stroke  = sel ? '#aa1133' : '#666';
    const color   = sel ? '#fff'    : '#222';
    return `<g>
      <circle cx="${p.cx}" cy="${p.cy}" r="10" fill="${fill}" stroke="${stroke}" stroke-width="1.8"/>
      <text x="${p.cx}" y="${p.cy + 4}" text-anchor="middle" font-size="9" fill="${color}"
        font-weight="${sel ? '700' : '400'}" font-family="Arial,sans-serif">${p.id}</text>
    </g>`;
  }).join('');
  return `<svg width="${size}" height="${size}" viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg">
    <rect width="110" height="110" rx="6" fill="#f9f9f9" stroke="#ccc" stroke-width="1"/>
    ${pins}
  </svg>`;
};

function Treninzi({ igraci, treninzi, sacuvajTrening, obrisiTrening, planoviTreninga = [], sacuvajPlan, azurirajPlan, obrisiPlan, setAktivna, otvoriUnos, jeAdmin, jeGost, jeTrener, korisnik, globalnaSezona }) {
  const mozePlan = jeAdmin || jeTrener;
  const igracZaUnos = !jeAdmin ? igraci.find(i => i.id === korisnik?.igracId) : null;

  const [prikaz, setPrikaz] = useState(otvoriUnos && !jeGost ? 'unos' : 'lista');
  const [listaPrikaz, setListaPrikaz] = useState('treninzi'); // 'treninzi' | 'statistika' | 'plan'

  // Plan treninga — perzistira u localStorage
  const [planVjezbe, setPlanVjezbe] = useState(() => {
    try { return JSON.parse(localStorage.getItem('kuglanje_plan_vjezbe') || '[]'); } catch { return []; }
  });
  const [planNaziv, setPlanNaziv] = useState(() => localStorage.getItem('kuglanje_plan_naziv') || '');
  const [editujemPlanId, setEditujemPlanId] = useState(null);

  const savePlan = (vjezbe) => {
    setPlanVjezbe(vjezbe);
    localStorage.setItem('kuglanje_plan_vjezbe', JSON.stringify(vjezbe));
  };
  const saveNaziv = (n) => { setPlanNaziv(n); localStorage.setItem('kuglanje_plan_naziv', n); };

  const handleSacuvajPlan = async () => {
    if (planVjezbe.length === 0) { alert('Dodaj bar jednu poziciju!'); return; }
    const naziv = planNaziv.trim() || `Plan ${new Date().toLocaleDateString('bs-Latn-BA')}`;
    if (editujemPlanId) {
      await azurirajPlan(editujemPlanId, { naziv, vjezbe: planVjezbe, ukupnoHitaca: ukupnoHitacaPlana });
      alert(`Plan "${naziv}" ažuriran!`);
    } else {
      await sacuvajPlan({ naziv, vjezbe: planVjezbe, ukupnoHitaca: ukupnoHitacaPlana });
      alert(`Plan "${naziv}" sačuvan!`);
    }
    setEditujemPlanId(null);
    savePlan([]);
    saveNaziv('');
  };
  const ucitajPlan = (plan) => {
    if (window.confirm(`Učitati plan "${plan.naziv}"? Trenutni plan će biti zamijenjen.`)) {
      savePlan(plan.vjezbe || []);
      saveNaziv(plan.naziv || '');
    }
  };
  const urediPlan = (plan) => {
    if (planVjezbe.length > 0 && !window.confirm('Imаš plan u radu. Prepisati sa odabranim?')) return;
    savePlan(plan.vjezbe || []);
    saveNaziv(plan.naziv || '');
    setEditujemPlanId(plan.id);
  };
  const dodajVjezbu = () => savePlan([...planVjezbe, { naziv: '', hitaca: 10 }]);
  const updateVjezba = (i, polje, v) => {
    const nv = planVjezbe.map((vj, j) => j === i ? { ...vj, [polje]: v } : vj);
    savePlan(nv);
  };
  const obrisiVjezbu = (i) => savePlan(planVjezbe.filter((_, j) => j !== i));
  const ukupnoHitacaPlana = planVjezbe.reduce((acc, v) => acc + (parseInt(v.hitaca) || 0), 0);
  const generiranTekst = `Trening za sutra:\n${planVjezbe.map((v, i) =>
    `${i + 1}. ${v.naziv}${v.hitaca ? ' ' + v.hitaca + ' hitaca' : ''}`
  ).join('\n')}\nZavrsen trening...`;
  const kopiraTekst = () => {
    navigator.clipboard.writeText(generiranTekst).then(() => alert('Kopirano u clipboard!'));
  };

  const toggleCunj = (vjezbaIdx, pinId) => {
    const cur = planVjezbe[vjezbaIdx].cunjevi || [];
    const novi = cur.includes(pinId) ? cur.filter(c => c !== pinId) : [...cur, pinId];
    updateVjezba(vjezbaIdx, 'cunjevi', novi);
  };

  const skiniPDF = () => {
    if (planVjezbe.length === 0) { alert('Nema pozicija u planu!'); return; }
    const genDate = new Date().toLocaleDateString('bs-Latn-BA');
    const celije = planVjezbe.map((v, i) => {
      const dijagram = makePinSVG(v.cunjevi || [], 64);
      const cunjeviTekst = v.cunjevi?.length
        ? `<div class="c-info">[${[...v.cunjevi].sort((a,b)=>a-b).join(',')}]</div>` : '';
      return `<div class="vjezba">
        <div class="vbr">${i + 1}.</div>
        <div class="vpin">${dijagram}</div>
        <div class="vinfo">
          <div class="vnaziv">${v.naziv || '—'}</div>
          <div class="vhit">${v.hitaca || 0} hitaca</div>
          ${cunjeviTekst}
        </div>
      </div>`;
    }).join('');
    const html = `<!DOCTYPE html><html lang="bs"><head><meta charset="UTF-8">
<title>Plan treninga</title>
<style>
@page{size:A4;margin:14mm 12mm}
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Segoe UI',Arial,sans-serif;font-size:12px;color:#111;background:#fff}
.header{display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:8px;margin-bottom:10px;border-bottom:2.5px solid #111}
.header h1{font-size:17px;font-weight:900;margin-bottom:2px}
.header .sub{font-size:10px;color:#555}
.meta{font-size:10px;color:#888;text-align:right;white-space:nowrap}
.summary{display:flex;gap:10px;margin-bottom:12px}
.sbox{border:1.5px solid #111;border-radius:5px;padding:4px 10px;text-align:center;min-width:56px}
.snum{font-size:16px;font-weight:800}
.slbl{font-size:8px;color:#555;text-transform:uppercase;letter-spacing:.3px}
.grid{column-count:2;column-gap:14px;margin-bottom:10px}
.vjezba{display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid #ddd;break-inside:avoid;page-break-inside:avoid}
.vjezba:last-child{border-bottom:none}
.vbr{font-size:16px;font-weight:900;color:#222;min-width:20px;text-align:right;flex-shrink:0}
.vpin{flex-shrink:0;line-height:0}
.vinfo{flex:1;min-width:0}
.vnaziv{font-size:12px;font-weight:700;line-height:1.2;margin-bottom:1px;word-break:break-word}
.vhit{font-size:11px;color:#333;font-weight:600}
.c-info{font-size:10px;color:#c0392b;font-weight:600}
.footer{font-size:9px;color:#bbb;text-align:center;border-top:1px solid #eee;padding-top:6px}
</style></head><body>
<div class="header">
  <div>
    <h1>🎳 Plan treninga${planNaziv ? ' — ' + planNaziv : ''}</h1>
    <div class="sub">Zagrijavanje: 15 hitaca &nbsp;·&nbsp; Trening: ${ukupnoHitacaPlana} hitaca &nbsp;·&nbsp; Ukupno: ${15 + ukupnoHitacaPlana} hitaca</div>
  </div>
  <div class="meta">Generirano: ${genDate}</div>
</div>
<div class="summary">
  <div class="sbox"><div class="snum">15</div><div class="slbl">Zagrijavanje</div></div>
  <div class="sbox"><div class="snum">${ukupnoHitacaPlana}</div><div class="slbl">Trening</div></div>
  <div class="sbox"><div class="snum">${planVjezbe.length}</div><div class="slbl">Pozicija</div></div>
  <div class="sbox"><div class="snum">${15 + ukupnoHitacaPlana}</div><div class="slbl">Ukupno</div></div>
</div>
<div class="grid">${celije}</div>
<div class="footer">kuglanje-arena.web.app</div>
</body></html>`;
    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    setTimeout(() => win.print(), 400);
  };
  const [filterSezona, setFilterSezona] = useState(globalnaSezona || '2025/2026');
  useEffect(() => { setFilterSezona(globalnaSezona); }, [globalnaSezona]);
  const [filterKlub, setFilterKlub] = useState('svi');
  const [filterOd, setFilterOd] = useState('');
  const [filterDo, setFilterDo] = useState('');
  const [forma, setForma] = useState({
    datum: new Date().toISOString().split('T')[0],
    sezona: globalnaSezona || '2025/2026',
    klub: igracZaUnos?.klub || KLUBOVI[0],
    igracId: igracZaUnos?.id || '',
    treningPozicija: false,
  });
  const [rezultat, setRezultat] = useState({ pune: '', cis: '', promasaji: '', setovi: {} });
  const [napredna, setNapredna] = useState(false);

  const filtriraniTreninzi = treninzi
    .filter(t => t.sezona === filterSezona)
    .filter(t => filterKlub === 'svi' || t.klub === filterKlub)
    .filter(t => !filterOd || t.datum >= filterOd)
    .filter(t => !filterDo || t.datum <= filterDo)
    .sort((a, b) => b.datum?.localeCompare(a.datum));

  // Statistika po igračima za odabranu sezonu
  const treninziSezone = treninzi.filter(t => t.sezona === filterSezona);
  const statistikaPoKlubu = KLUBOVI.map(klub => {
    const trebaTreninzi = treninziSezone.filter(t => t.klub === klub);
    const igracIdsSet = new Set();
    trebaTreninzi.forEach(t => (t.rezultati || []).forEach(r => { if (r.igracId) igracIdsSet.add(r.igracId); }));

    const igraciStats = [...igracIdsSet].map(igracId => {
      const igracObj = igraci.find(i => i.id === igracId);
      const prvaUt = trebaTreninzi.find(t => t.rezultati?.some(r => r.igracId === igracId));
      const prviRez = prvaUt?.rezultati?.find(r => r.igracId === igracId);
      const ime = igracObj?.ime || prviRez?.ime || 'Nepoznat';

      let nastupa = 0, pozicija = 0, ukupnoCunj = 0, ukupnoPune = 0, ukupnoCis = 0, ukupnoPromasaji = 0;
      trebaTreninzi.forEach(t => {
        const r = (t.rezultati || []).find(r => r.igracId === igracId);
        if (!r) return;
        nastupa++;
        if (t.treningPozicija) pozicija++;
        ukupnoCunj += r.ukupno || 0;
        ukupnoPromasaji += r.promasaji || 0;
        // Pokupi pune/cis: iz naprednih setova ili direktno
        if (r.napredna && r.setovi) {
          [1, 2, 3, 4].forEach(s => {
            const set = r.setovi[s] || {};
            ukupnoPune += parseFloat(set.pune) || 0;
            ukupnoCis += parseFloat(set.cis) || 0;
          });
        } else {
          ukupnoPune += r.ukupnoPune || 0;
          ukupnoCis += r.ukupnoCis || 0;
        }
      });

      if (nastupa === 0) return null;
      return {
        id: igracId, ime,
        nastupa, pozicija,
        prosjekUkupno: Math.round(ukupnoCunj / nastupa),
        prosjekPoSetu: Math.round(ukupnoCunj / nastupa / 4),
        prosjekPune: Math.round((ukupnoPune / nastupa) * 10) / 10,
        prosjekCis: Math.round((ukupnoCis / nastupa) * 10) / 10,
        prosjekPromasaja: Math.round((ukupnoPromasaji / nastupa) * 10) / 10,
      };
    }).filter(Boolean).sort((a, b) => b.prosjekUkupno - a.prosjekUkupno);

    return { klub, igraciStats };
  });

  const updateSet = (set, polje, vrijednost) => {
    setRezultat(prev => ({
      ...prev,
      setovi: { ...prev.setovi, [set]: { ...prev.setovi?.[set], [polje]: vrijednost } }
    }));
  };

  const izracunajUkupno = () => {
    if (napredna) {
      let ukupno = 0, promasaji = 0;
      [1, 2, 3, 4].forEach(s => {
        const set = rezultat.setovi?.[s] || {};
        ukupno += parseFloat(set.ukupno) || 0;
        promasaji += parseFloat(set.promasaji) || 0;
      });
      return { ukupno, promasaji };
    }
    const pune = parseFloat(rezultat.pune) || 0;
    const cis = parseFloat(rezultat.cis) || 0;
    return {
      ukupno: pune + cis,
      promasaji: parseFloat(rezultat.promasaji) || 0,
      ukupnoPune: pune,
      ukupnoCis: cis,
    };
  };

  const handleSacuvaj = async () => {
    const igracId = jeAdmin ? forma.igracId : korisnik?.igracId;
    if (!igracId) return alert('Odaberi igrača!');
    const igrac = igraci.find(i => i.id === igracId);
    if (!igrac) return alert('Igrač nije pronađen!');
    const s = izracunajUkupno();
    if (s.ukupno === 0) return alert('Upiši rezultat!');

    const setoviZaBazu = napredna
      ? Object.fromEntries(
          [1, 2, 3, 4].map(sNum => {
            const set = rezultat.setovi?.[sNum] || {};
            const pune = parseFloat(set.pune) || 0;
            const ukupnoSeta = parseFloat(set.ukupno) || 0;
            const cis = Math.max(0, ukupnoSeta - pune);
            return [sNum, { pune, ukupno: ukupnoSeta, cis, promasaji: parseFloat(set.promasaji) || 0 }];
          })
        )
      : null;

    // Za napredni mod izračunaj ukupno pune i cis
    let ukupnoPune = s.ukupnoPune || 0;
    let ukupnoCis = s.ukupnoCis || 0;
    if (napredna && setoviZaBazu) {
      [1, 2, 3, 4].forEach(sNum => {
        const set = setoviZaBazu[sNum] || {};
        ukupnoPune += set.pune || 0;
        ukupnoCis += set.cis || 0;
      });
    }

    const rezultatZaBazu = {
      igracId: igrac.id,
      ime: igrac.ime,
      ukupno: s.ukupno,
      ukupnoPune,
      ukupnoCis,
      promasaji: s.promasaji,
      napredna,
      setovi: setoviZaBazu,
    };

    await sacuvajTrening({
      datum: forma.datum,
      sezona: forma.sezona,
      klub: igrac.klub,
      treningPozicija: forma.treningPozicija || false,
      rezultati: [rezultatZaBazu],
    });

    setRezultat({ pune: '', cis: '', promasaji: '', setovi: {} });
    setNapredna(false);
    setPrikaz('lista');
    alert('Trening sačuvan!');
  };

  const stat = izracunajUkupno();

  // Totali naprednog moda
  const napredniTotali = [1, 2, 3, 4].reduce((acc, s) => {
    const set = rezultat.setovi?.[s] || {};
    const pune = parseFloat(set.pune) || 0;
    const ukupnoSeta = parseFloat(set.ukupno) || 0;
    const cis = Math.max(0, ukupnoSeta - pune);
    return {
      pune: acc.pune + pune,
      ukupno: acc.ukupno + ukupnoSeta,
      cis: acc.cis + cis,
      promasaji: acc.promasaji + (parseFloat(set.promasaji) || 0),
    };
  }, { pune: 0, ukupno: 0, cis: 0, promasaji: 0 });

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div className="page-title" style={{ margin: 0 }}>Treninzi</div>
        {!jeGost && (
          <button className="btn-primary"
            onClick={() => setPrikaz(prikaz === 'unos' ? 'lista' : 'unos')}>
            {prikaz === 'unos' ? '← Nazad' : '+ Novi trening'}
          </button>
        )}
      </div>

      {prikaz === 'lista' && (
        <>
          <div className="filter-bar">
            {SEZONE.map(s => (
              <button key={s} className={`filter-btn ${filterSezona === s ? 'active' : ''}`}
                onClick={() => setFilterSezona(s)}>{s}</button>
            ))}
          </div>
          <div className="filter-bar">
            {['svi', ...KLUBOVI].map(k => (
              <button key={k} className={`filter-btn ${filterKlub === k ? 'active' : ''}`}
                onClick={() => setFilterKlub(k)}>
                {k === 'svi' ? 'Svi klubovi' : k}
              </button>
            ))}
          </div>

          {/* Sub-tabovi */}
          <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            {[
              { id: 'treninzi', naziv: 'Treninzi' },
              { id: 'statistika', naziv: 'Statistika' },
              ...(mozePlan ? [{ id: 'plan', naziv: '📋 Plan treninga' }] : []),
            ].map(t => (
              <button key={t.id}
                className={listaPrikaz === t.id ? 'btn-primary btn-sm' : 'filter-btn'}
                onClick={() => setListaPrikaz(t.id)}>{t.naziv}</button>
            ))}
          </div>

          {/* Plan treninga */}
          {listaPrikaz === 'plan' && mozePlan && (
            <div>
              <div className="card" style={{ marginBottom: '16px' }}>
                <div style={{ marginBottom: '16px' }}>
                  <div className="section-title" style={{ margin: 0 }}>Kreiraj plan treninga</div>
                </div>
                {/* Naziv plana */}
                <div style={{ marginBottom: '14px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <input
                    value={planNaziv}
                    onChange={e => saveNaziv(e.target.value)}
                    placeholder="Naziv plana (npr. Trening subota)"
                    style={{ flex: 1, minWidth: '180px' }}
                  />
                  {editujemPlanId && (
                    <button className="btn-secondary btn-sm" onClick={() => { setEditujemPlanId(null); savePlan([]); saveNaziv(''); }}>
                      Otkaži izmjene
                    </button>
                  )}
                  <button className="btn-primary btn-sm"
                    style={{ background: editujemPlanId ? '#ffc107' : '#2ed573', color: '#000', fontWeight: '700', whiteSpace: 'nowrap' }}
                    onClick={handleSacuvajPlan}>
                    {editujemPlanId ? '✏️ Sačuvaj izmjene' : '💾 Sačuvaj plan'}
                  </button>
                </div>
                {editujemPlanId && (
                  <div style={{ marginBottom: '10px', padding: '6px 12px', background: 'rgba(255,193,7,0.1)', borderRadius: '6px', border: '1px solid rgba(255,193,7,0.3)', fontSize: '12px', color: '#ffc107' }}>
                    ✏️ Uređuješ plan — izmjene će prepisati sačuvanu verziju
                  </div>
                )}

                {/* Brojač hitaca */}
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap' }}>
                  <div style={{ display: 'flex', gap: '12px' }}>
                    <div className="stat-card" style={{ minWidth: '80px' }}>
                      <div className="broj" style={{ color: '#ffc107', fontSize: '22px' }}>15</div>
                      <div className="naziv">Zagrijavanje</div>
                    </div>
                    <div className="stat-card" style={{ minWidth: '80px' }}>
                      <div className="broj" style={{
                        fontSize: '22px',
                        color: ukupnoHitacaPlana > 120 ? '#e94560' : ukupnoHitacaPlana === 120 ? '#2ed573' : '#fff'
                      }}>{ukupnoHitacaPlana}<span style={{ fontSize: '13px', color: '#666688' }}>/120</span></div>
                      <div className="naziv">Hitaca</div>
                    </div>
                    <div className="stat-card" style={{ minWidth: '80px' }}>
                      <div className="broj" style={{ fontSize: '22px', color: '#5378ff' }}>{15 + ukupnoHitacaPlana}</div>
                      <div className="naziv">Ukupno</div>
                    </div>
                  </div>
                  {/* Progress bar */}
                  <div style={{ flex: 1, minWidth: '140px' }}>
                    <div style={{ fontSize: '11px', color: '#666688', marginBottom: '5px' }}>
                      {ukupnoHitacaPlana < 120 ? `Nedostaje ${120 - ukupnoHitacaPlana} hitaca` :
                       ukupnoHitacaPlana === 120 ? '✓ Tačno 120 hitaca' :
                       `Prekoračenje za ${ukupnoHitacaPlana - 120} hitaca`}
                    </div>
                    <div style={{ background: '#2a2a4a', borderRadius: '4px', height: '10px' }}>
                      <div style={{
                        background: ukupnoHitacaPlana > 120 ? '#e94560' : ukupnoHitacaPlana === 120 ? '#2ed573' : '#5378ff',
                        width: Math.min(100, (ukupnoHitacaPlana / 120) * 100) + '%',
                        height: '100%', borderRadius: '4px', transition: 'width 0.2s',
                      }} />
                    </div>
                  </div>
                </div>

                {/* Lista pozicija */}
                {planVjezbe.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '24px', color: '#666688', fontSize: '14px' }}>
                    Nema pozicija. Klikni dugme ispod da dodaš prvu poziciju.
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {planVjezbe.map((v, i) => {
                      const odabrani = v.cunjevi || [];
                      return (
                        <div key={i} style={{ background: '#0f0f1a', borderRadius: '10px', padding: '12px', border: '1px solid #2a2a4a' }}>
                          {/* Header reda: broj + inputs + brisanje */}
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '10px', flexWrap: 'wrap' }}>
                            <div style={{ color: '#e94560', fontWeight: '800', fontSize: '16px', minWidth: '22px' }}>{i + 1}.</div>
                            <input
                              value={v.naziv}
                              onChange={e => updateVjezba(i, 'naziv', e.target.value)}
                              placeholder="Naziv pozicije..."
                              style={{ flex: 1, minWidth: '120px' }}
                            />
                            <input
                              type="number" min="1" max="120"
                              value={v.hitaca}
                              onChange={e => updateVjezba(i, 'hitaca', e.target.value)}
                              style={{ width: '62px', textAlign: 'center' }}
                            />
                            <span style={{ fontSize: '12px', color: '#666688' }}>h</span>
                            <button onClick={() => obrisiVjezbu(i)}
                              style={{ background: 'rgba(233,69,96,0.12)', color: '#e94560', border: '1px solid rgba(233,69,96,0.3)', borderRadius: '6px', cursor: 'pointer', fontSize: '16px', padding: '1px 9px' }}>
                              ×
                            </button>
                          </div>
                          {/* Dijagram čunjeva — puni red, touch-friendly */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ fontSize: '10px', color: '#666688', writingMode: 'vertical-rl', textOrientation: 'mixed', transform: 'rotate(180deg)', flexShrink: 0 }}>klikni čunj</div>
                            <svg width="110" height="110" viewBox="0 0 110 110" style={{ cursor: 'pointer', display: 'block', touchAction: 'manipulation' }}>
                              <rect width="110" height="110" rx="8" fill="#16162a" stroke="#2a2a4a" strokeWidth="1.5"/>
                              {CUNJEVI.map(p => {
                                const sel = odabrani.includes(p.id);
                                const je9 = p.id === 9;
                                return (
                                  <g key={p.id} onClick={() => toggleCunj(i, p.id)} style={{ cursor: 'pointer' }}>
                                    <circle cx={p.cx} cy={p.cy} r="13"
                                      fill={sel ? '#e94560' : je9 ? '#2a1a2e' : '#1e1e3a'}
                                      stroke={sel ? '#ff6b8a' : je9 ? '#e94560' : '#3a3a6a'}
                                      strokeWidth="1.5"
                                    />
                                    <text x={p.cx} y={p.cy + 4.5} textAnchor="middle" fontSize="10"
                                      fill={sel ? '#fff' : je9 ? '#e94560' : '#8888aa'}
                                      fontWeight={sel || je9 ? '700' : '400'}
                                      style={{ userSelect: 'none', pointerEvents: 'none' }}>
                                      {p.id}
                                    </text>
                                  </g>
                                );
                              })}
                            </svg>
                            {odabrani.length > 0 && (
                              <div style={{ fontSize: '12px', color: '#e94560', fontWeight: '600' }}>
                                [{[...odabrani].sort((a,b)=>a-b).join(', ')}]
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Dodaj poziciju — uvijek ispod zadnje */}
                <div style={{ marginTop: '12px' }}>
                  <button className="btn-primary btn-sm" onClick={dodajVjezbu}
                    style={{ width: '100%', padding: '10px', fontSize: '14px' }}>
                    + Dodaj poziciju
                  </button>
                </div>
              </div>

              {/* Sačuvani planovi — na dnu */}
              {planoviTreninga.length > 0 && (
                <div className="card" style={{ marginBottom: '16px' }}>
                  <div className="section-title" style={{ marginBottom: '10px' }}>📁 Sačuvani planovi</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {[...planoviTreninga].sort((a, b) => b.kreiran?.localeCompare(a.kreiran)).map(plan => (
                      <div key={plan.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', background: '#0f0f1a', borderRadius: '8px', border: '1px solid #2a2a4a', flexWrap: 'wrap' }}>
                        <div style={{ flex: 1, minWidth: '120px' }}>
                          <div style={{ fontWeight: '600', color: '#fff', fontSize: '14px' }}>{plan.naziv}</div>
                          <div style={{ fontSize: '11px', color: '#666688', marginTop: '2px' }}>
                            {plan.vjezbe?.length || 0} pozicija · {plan.ukupnoHitaca || 0} hitaca
                            {plan.kreiran && ` · ${new Date(plan.kreiran).toLocaleDateString('bs-Latn-BA')}`}
                          </div>
                        </div>
                        <button className="btn-secondary btn-sm" onClick={() => ucitajPlan(plan)}>Učitaj</button>
                        <button className="btn-edit btn-sm" onClick={() => urediPlan(plan)}>✏️ Uredi</button>
                        {jeAdmin && (
                          <button className="btn-danger btn-sm"
                            onClick={() => { if (window.confirm(`Obrisati plan "${plan.naziv}"?`)) obrisiPlan(plan.id); }}>
                            Obriši
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Generirani tekst */}
              {planVjezbe.length > 0 && (
                <div className="card">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
                    <div className="section-title" style={{ margin: 0 }}>Generirani plan</div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button className="btn-primary btn-sm"
                        style={{ background: '#25D366', borderColor: '#25D366', color: '#fff' }}
                        onClick={kopiraTekst}>
                        📋 Kopiraj tekst
                      </button>
                      <button className="btn-primary btn-sm"
                        style={{ background: '#e94560', borderColor: '#e94560', color: '#fff' }}
                        onClick={skiniPDF}>
                        🖨️ Skini PDF
                      </button>
                    </div>
                  </div>
                  <pre style={{
                    background: '#0f0f1a', borderRadius: '8px', padding: '16px', fontSize: '13px',
                    color: '#ddd', lineHeight: '1.8', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                    border: '1px solid #2a2a4a', margin: 0,
                  }}>
                    {generiranTekst}
                  </pre>
                </div>
              )}
            </div>
          )}

          {/* Statistika treninga po igračima */}
          {listaPrikaz === 'statistika' && (
            <div>
              {KLUBOVI.map(klub => {
                const stat = statistikaPoKlubu.find(s => s.klub === klub);
                if (!stat || stat.igraciStats.length === 0) return null;
                return (
                  <div key={klub} style={{ marginBottom: '24px' }}>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: '#e94560', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #2a2a4a' }}>
                      {klub}
                    </div>
                    <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
                      <div style={{ overflowX: 'auto' }}>
                        <table style={{ minWidth: '600px' }}>
                          <thead>
                            <tr>
                              <th>Igrač</th>
                              <th style={{ textAlign: 'center' }}>Nast.</th>
                              <th style={{ textAlign: 'center', color: '#ffc107' }}>🎯 Poz.</th>
                              <th style={{ textAlign: 'center', color: '#e94560' }}>Ø Ukupno</th>
                              <th style={{ textAlign: 'center' }}>Ø/set</th>
                              <th style={{ textAlign: 'center' }}>Ø Pune</th>
                              <th style={{ textAlign: 'center', color: '#2ed573' }}>Ø Čišćenje</th>
                              <th style={{ textAlign: 'center', color: '#666688' }}>Ø Prom.</th>
                            </tr>
                          </thead>
                          <tbody>
                            {stat.igraciStats.map(ig => (
                              <tr key={ig.id} style={{ cursor: 'pointer' }}
                                onClick={() => setAktivna({ strana: 'profil', igracId: ig.id, pocetniTab: 'treninzi', povratakNa: { strana: 'treninzi' } })}>
                                <td style={{ fontWeight: '600', color: '#e94560' }}>{ig.ime}</td>
                                <td style={{ textAlign: 'center', color: '#aaa' }}>{ig.nastupa}</td>
                                <td style={{ textAlign: 'center', fontWeight: '700', color: ig.pozicija > 0 ? '#ffc107' : '#444466' }}>{ig.pozicija || 0}</td>
                                <td style={{ textAlign: 'center', fontWeight: '700', color: '#e94560', fontSize: '16px' }}>{ig.prosjekUkupno}</td>
                                <td style={{ textAlign: 'center', fontWeight: '600', color: '#fff' }}>{ig.prosjekPoSetu}</td>
                                <td style={{ textAlign: 'center' }}>{ig.prosjekPune || '—'}</td>
                                <td style={{ textAlign: 'center', color: '#2ed573' }}>{ig.prosjekCis || '—'}</td>
                                <td style={{ textAlign: 'center', color: '#666688' }}>{ig.prosjekPromasaja}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                );
              })}
              {statistikaPoKlubu.every(s => s.igraciStats.length === 0) && (
                <div className="card empty-state">
                  <div className="icon">📊</div>
                  <p>Nema podataka za {filterSezona}.</p>
                </div>
              )}
            </div>
          )}

          {/* Lista treninga */}
          {listaPrikaz === 'treninzi' && (
            <>
              <div className="card" style={{ marginBottom: '16px', padding: '14px 18px' }}>
                <div className="form-row" style={{ alignItems: 'flex-end' }}>
                  <div className="form-group">
                    <label>Od datuma</label>
                    <input type="date" value={filterOd} onChange={e => setFilterOd(e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label>Do datuma</label>
                    <input type="date" value={filterDo} onChange={e => setFilterDo(e.target.value)} />
                  </div>
                  {(filterOd || filterDo) && (
                    <button className="btn-secondary btn-sm"
                      onClick={() => { setFilterOd(''); setFilterDo(''); }}>
                      Resetuj datume
                    </button>
                  )}
                </div>
              </div>

              {filtriraniTreninzi.length === 0 ? (
                <div className="card empty-state">
                  <div className="icon">🏋️</div>
                  <p>Nema treninga za odabrani period</p>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {filtriraniTreninzi.map(t => (
                    <div key={t.id} className="card" style={{ padding: '14px 18px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                        <div>
                          <div style={{ fontSize: '15px', fontWeight: '600', color: '#fff' }}>{t.klub}</div>
                          <div style={{ fontSize: '12px', color: '#666688', marginTop: '2px' }}>{t.datum} • {t.sezona}</div>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          <span className="badge badge-blue">{t.rezultati?.length || 0} igrača</span>
                          {jeAdmin && (
                            <button className="btn-danger btn-sm"
                              onClick={() => { if (window.confirm('Obrisati trening?')) obrisiTrening(t.id); }}>
                              Obriši
                            </button>
                          )}
                        </div>
                      </div>
                      <table>
                        <thead>
                          <tr>
                            <th>Igrač</th>
                            <th style={{ textAlign: 'center' }}>Ukupno</th>
                            <th style={{ textAlign: 'center' }}>Promašaji</th>
                            <th style={{ textAlign: 'center' }}>Prosjek/set</th>
                          </tr>
                        </thead>
                        <tbody>
                          {t.rezultati?.sort((a, b) => b.ukupno - a.ukupno).map((r, i) => (
                            <tr key={i} style={{ cursor: 'pointer' }}
                              onClick={() => setAktivna({ strana: 'profil', igracId: r.igracId, pocetniTab: 'treninzi', povratakNa: { strana: 'treninzi' } })}>
                              <td style={{ color: '#e94560', fontWeight: '500' }}>{r.ime}</td>
                              <td style={{ textAlign: 'center', fontWeight: '700', color: '#e94560' }}>{r.ukupno}</td>
                              <td style={{ textAlign: 'center', color: '#666688' }}>{r.promasaji || 0}</td>
                              <td style={{ textAlign: 'center', color: '#fff' }}>{Math.round(r.ukupno / 4)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </>
      )}

      {prikaz === 'unos' && !jeGost && (
        <div>
          <div className="card" style={{ marginBottom: '16px' }}>
            <div className="section-title">Informacije o treningu</div>
            <div className="form-row">
              <div className="form-group">
                <label>Sezona</label>
                <select value={forma.sezona} onChange={e => setForma({ ...forma, sezona: e.target.value })}>
                  {SEZONE.map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Datum</label>
                <input type="date" value={forma.datum}
                  onChange={e => setForma({ ...forma, datum: e.target.value })} />
              </div>
              {jeAdmin && (
                <div className="form-group">
                  <label>Igrač</label>
                  <select value={forma.igracId}
                    onChange={e => setForma({ ...forma, igracId: e.target.value })}>
                    <option value="">-- odaberi igrača --</option>
                    {[...igraci].sort((a, b) => a.ime.localeCompare(b.ime)).map(i => (
                      <option key={i.id} value={i.id}>{i.ime} ({i.klub})</option>
                    ))}
                  </select>
                </div>
              )}
              {!jeAdmin && (
                <div className="form-group">
                  <label>Igrač</label>
                  <div style={{ padding: '9px 12px', background: '#12122a', border: '1px solid #2a2a4a', borderRadius: '6px', color: '#e94560', fontWeight: '600' }}>
                    {igracZaUnos?.ime} ({igracZaUnos?.klub})
                  </div>
                </div>
              )}
              <div className="form-group" style={{ justifyContent: 'flex-end' }}>
                <label style={{ fontSize: '11px', color: '#666688', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Tip treninga</label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '9px 12px', background: forma.treningPozicija ? 'rgba(233,69,96,0.1)' : '#12122a', border: `1px solid ${forma.treningPozicija ? '#e94560' : '#2a2a4a'}`, borderRadius: '6px', transition: 'all 0.2s' }}>
                  <input type="checkbox" checked={forma.treningPozicija}
                    onChange={e => { const v = e.target.checked; setForma(prev => ({ ...prev, treningPozicija: v })); }} />
                  <span style={{ color: forma.treningPozicija ? '#e94560' : '#aaa', fontWeight: forma.treningPozicija ? '700' : '400', fontSize: '14px' }}>
                    🎯 Trening pozicija
                  </span>
                </label>
              </div>
            </div>
          </div>

          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <div className="section-title" style={{ margin: 0 }}>Rezultat treninga</div>
              <button onClick={() => setNapredna(!napredna)}
                style={{
                  padding: '6px 14px', fontSize: '13px', borderRadius: '6px',
                  background: napredna ? '#e94560' : '#16162a',
                  color: napredna ? 'white' : '#888899',
                  border: '1px solid #2a2a4a', cursor: 'pointer',
                }}>
                {napredna ? 'Osnovno' : 'Po setovima'}
              </button>
            </div>

            {!napredna ? (
              <div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Pune</label>
                    <input type="number" min="0" step="0.5" placeholder="npr. 240"
                      value={rezultat.pune}
                      onChange={e => setRezultat({ ...rezultat, pune: e.target.value })}
                      style={{ width: '120px' }} />
                  </div>
                  <div className="form-group">
                    <label>Čišćenje</label>
                    <input type="number" min="0" step="0.5" placeholder="npr. 320"
                      value={rezultat.cis}
                      onChange={e => setRezultat({ ...rezultat, cis: e.target.value })}
                      style={{ width: '120px' }} />
                  </div>
                  <div className="form-group">
                    <label>Promašaji</label>
                    <input type="number" min="0" step="1" placeholder="npr. 3"
                      value={rezultat.promasaji}
                      onChange={e => setRezultat({ ...rezultat, promasaji: e.target.value })}
                      style={{ width: '100px' }} />
                  </div>
                  {stat.ukupno > 0 && (
                    <div className="form-group">
                      <label>Ukupno / Prosjek/set</label>
                      <div style={{ padding: '9px 0', fontSize: '20px', fontWeight: '700', color: '#e94560' }}>
                        {stat.ukupno} / {Math.round(stat.ukupno / 4)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <table style={{ marginBottom: '8px' }}>
                <thead>
                  <tr>
                    <th>Set</th>
                    <th style={{ textAlign: 'center' }}>Pune</th>
                    <th style={{ textAlign: 'center' }}>Ukupno</th>
                    <th style={{ textAlign: 'center' }}>Promašaji</th>
                    <th style={{ textAlign: 'center', color: '#2ed573' }}>Čišćenje</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4].map(s => {
                    const set = rezultat.setovi?.[s] || {};
                    const pune = parseFloat(set.pune) || 0;
                    const ukupnoSeta = parseFloat(set.ukupno) || 0;
                    const cis = ukupnoSeta > 0 ? Math.max(0, ukupnoSeta - pune) : 0;
                    return (
                      <tr key={s}>
                        <td style={{ color: '#e94560', fontWeight: '600' }}>Set {s}</td>
                        <td style={{ padding: '4px', textAlign: 'center' }}>
                          <input type="number" min="0" step="0.5" value={set.pune || ''}
                            onChange={e => updateSet(s, 'pune', e.target.value)}
                            style={{ width: '60px', textAlign: 'center' }} />
                        </td>
                        <td style={{ padding: '4px', textAlign: 'center' }}>
                          <input type="number" min="0" step="0.5" value={set.ukupno || ''}
                            onChange={e => updateSet(s, 'ukupno', e.target.value)}
                            style={{ width: '60px', textAlign: 'center' }} />
                        </td>
                        <td style={{ padding: '4px', textAlign: 'center' }}>
                          <input type="number" min="0" step="1" value={set.promasaji || ''}
                            onChange={e => updateSet(s, 'promasaji', e.target.value)}
                            style={{ width: '60px', textAlign: 'center' }} />
                        </td>
                        <td style={{ textAlign: 'center', fontWeight: '700', color: '#2ed573' }}>
                          {ukupnoSeta > 0 ? cis : '—'}
                        </td>
                      </tr>
                    );
                  })}
                  {/* Ukupan rezultat ispod Set 4 */}
                  <tr style={{ borderTop: '2px solid #e94560', background: '#1a1a2e' }}>
                    <td style={{ fontWeight: '700', color: '#fff' }}>Ukupno</td>
                    <td style={{ textAlign: 'center', fontWeight: '700', color: '#fff' }}>{napredniTotali.pune || '—'}</td>
                    <td style={{ textAlign: 'center', fontWeight: '700', color: '#e94560', fontSize: '16px' }}>{napredniTotali.ukupno || '—'}</td>
                    <td style={{ textAlign: 'center', color: '#666688' }}>{napredniTotali.promasaji || '—'}</td>
                    <td style={{ textAlign: 'center', fontWeight: '700', color: '#2ed573' }}>{napredniTotali.cis || '—'}</td>
                  </tr>
                </tbody>
              </table>
            )}

            <div style={{ marginTop: '20px' }}>
              <button className="btn-primary" onClick={handleSacuvaj}
                style={{ fontSize: '15px', padding: '12px 32px' }}>
                Sačuvaj trening
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Treninzi;
